import { useEffect } from 'react';
import type { RefObject } from 'react';

/**
 * Minimal accessibility for custom (non-Ionic) dialogs: closes on Escape and
 * moves focus into the dialog when it opens, restoring it when it closes.
 */
export function useDialogA11y(
  open: boolean,
  onClose: () => void,
  initialFocusRef: RefObject<HTMLElement>,
) {
  useEffect(() => {
    if (!open) return;
    const previouslyFocused =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
    initialFocusRef.current?.focus();

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      previouslyFocused?.focus();
    };
  }, [open, onClose, initialFocusRef]);
}
